<h1 mat-dialog-title [attr.data-cy]="'cctdctd_h1_1_4_'">Ticket erstellen</h1>
<div mat-dialog-content>
    <div class="one-row">
        <mat-form-field style="width: 100%">
            <mat-label>Betreff</mat-label>
            <input [formControl]="titelCtrl" matInput [attr.data-cy]="'cctdctd_input_1_1_'" />
        </mat-form-field>
    </div>

    <mat-form-field style="width: 100%">
        <mat-label>Beschreibung</mat-label>
        <textarea
            [formControl]="descriptionCtrl"
            matInput
            style="height: 100px"
            [attr.data-cy]="'cctdctd_ta_1_1_'"
        ></textarea>
    </mat-form-field>

    <div class="one-row">
        <ng-container *ngIf="data?.screenshot">
            <div style="width: 25%; height: 12.0625vw; border: 1.5px solid black; border-radius: 8px">
                <img
                    (click)="openImageDialog(data.screenshot)"
                    *ngIf="data.screenshot && includeScreenshot"
                    [src]="data.screenshot"
                    alt="Screenshot"
                    style="width: 100%; height: 100%; object-fit: contain"
                />
            </div>

            <div
                style="
                    margin-left: 16px;
                    margin-top: auto;
                    margin-right: auto;
                    display: flex;
                    align-items: center;
                    padding-top: 6vw;
                "
            >
                <mat-checkbox [(ngModel)]="includeScreenshot" [attr.data-cy]="'cctdctd_mat-checkbox_1_3_'"
                    >Screenshot senden?</mat-checkbox
                >
            </div>
        </ng-container>

        <div *ngIf="!isMobile" style="margin-bottom: auto">
            <div class="one-row" style="margin-right: 0">
                <span class="spacer"></span>
                <button
                    (click)="uploadFiles()"
                    color="primary"
                    mat-stroked-button
                    style="margin-left: 16px"
                    [attr.data-cy]="'cctdctd_button_1_0_'"
                >
                    <mat-icon [attr.data-cy]="'cctdctd_mat-icon_1_2_'">attach_file</mat-icon>
                    <span style="vertical-align: middle">Datei anfügen</span>
                </button>
            </div>
            <div class="one-row">
                <span class="spacer"></span>
                <input
                    (change)="onFileSelected($event)"
                    accept=".jpg,.jpeg,.png,.pdf,.csv,.xls,.xlsx"
                    class="file-upload"
                    id="fileInput"
                    multiple="multiple"
                    style="display: none"
                    type="file"
                    [attr.data-cy]="'cctdctd_input_2_1_'"
                />
                <div *ngIf="selectedFiles.length > 0" style="margin-top: 8px; text-align: right">
                    <div *ngFor="let file of selectedFiles; let i = index" style="display: flex; align-items: center">
                        <mat-icon [attr.data-cy]="'cctdctd_mat-icon_2_2_' + i">attach_file</mat-icon>
                        <span style="margin-left: 8px; padding-right: 12px">{{ file.name }}</span>
                        <mat-icon
                            (click)="removeFile(file)"
                            style="margin-left: auto; cursor: pointer"
                            [attr.data-cy]="'cctdctd_mat-icon_3_2_' + i"
                            >delete
                        </mat-icon>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="isMobile">
            <button
                (click)="uploadFiles()"
                color="primary"
                mat-stroked-button
                style="width: 100%"
                [attr.data-cy]="'cctdctd_button_2_0_'"
            >
                <mat-icon [attr.data-cy]="'cctdctd_mat-icon_4_2_'">attach_file</mat-icon>
                <span style="vertical-align: middle">Datei anfügen</span>
            </button>
            <input
                (change)="onFileSelected($event)"
                accept=".jpg,.jpeg,.png,.pdf,.csv,.xls,.xlsx"
                class="file-upload"
                id="fileInput"
                multiple="multiple"
                style="display: none"
                type="file"
                [attr.data-cy]="'cctdctd_input_3_1_'"
            />
            <div *ngIf="selectedFiles.length > 0" style="margin-top: 8px; text-align: right">
                <div *ngFor="let file of selectedFiles; let i = index" style="display: flex; align-items: center">
                    <mat-icon [attr.data-cy]="'cctdctd_mat-icon_5_2_' + i">attach_file</mat-icon>
                    <span
                        style="
                            margin-left: 8px;
                            padding-right: 12px;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            max-width: 150px;
                            display: inline-block;
                        "
                    >
                        {{ file.name }}
                    </span>
                    <mat-icon
                        (click)="removeFile(file)"
                        style="margin-left: auto; cursor: pointer"
                        [attr.data-cy]="'cctdctd_mat-icon_6_2_' + i"
                        >delete</mat-icon
                    >
                </div>
            </div>
        </div>
    </div>
</div>

<div align="end" mat-dialog-actions>
    <button (click)="dialogRef.close()" mat-button [attr.data-cy]="'cctdctd_button_3_0_'">Abbrechen</button>
    <button
        (click)="createTicket()"
        [disabled]="!isValid()"
        color="accent"
        mat-flat-button
        [attr.data-cy]="'cctdctd_button_4_0_'"
        >Senden</button
    >
</div>
